<template>
<listp type="official" />
</template>
<script>
import listp from '@/modules/CA_SP/components/spci/list.vue';
export default { components: { listp } };
</script>
